module.exports = __webpack_public_path__ + "img/store.4e2e642c.svg";